import { render, staticRenderFns } from "./WarrantsDetails.vue?vue&type=template&id=7dd953e4&scoped=true"
import script from "./WarrantsDetails.vue?vue&type=script&lang=js"
export * from "./WarrantsDetails.vue?vue&type=script&lang=js"
import style0 from "./WarrantsDetails.vue?vue&type=style&index=0&id=7dd953e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd953e4",
  null
  
)

export default component.exports